import { compose } from 'redux'
import { connect } from 'react-redux'
import { uiProgramSetEditSelection } from '../../../actions';
import WrapperPageEdit from '../present/WrapperPageEdit';
import toJS from '../../../hoc/toJS';


const mapDispatchToProps = (dispatch, ownProps) => ({
    clickEdit: () => {
        dispatch(uiProgramSetEditSelection(ownProps.id, ownProps.type))
    }
})

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(WrapperPageEdit)